const CustomSelect = {


	init: () => {
		CustomSelect.initSelectOpen();
		CustomSelect.initOptionOnClick();
		CustomSelect.initCloseOnOtherClick();
	},

	initCloseOnOtherClick: () => {
		document.body.addEventListener('click', (ev) => {
			CustomSelect.closeOptions();
		});
		const selects = document.querySelectorAll(`[data-custom-select]`);
		selects.forEach((element) => {
			element.addEventListener('click', (ev) => { ev.stopPropagation(); })
		})
	},

	closeOptions: () => {
		const selects = document.querySelectorAll(`[data-custom-select]`);
		selects.forEach((element) => {
			element.classList.remove('active');
		})
	},

	initSelectOpen: () => {
		const selects = document.querySelectorAll(`[data-custom-select-current]`);
		selects.forEach((select) => {
		    select.addEventListener('click', () => {
				const parent = select.closest('[data-custom-select]');
				parent.classList.toggle('active');
			})
		})
	},

	initOptionOnClick: () => {
		const options = document.querySelectorAll(`[data-custom-select-option]`);
		options.forEach((option) => {
		    option.addEventListener('click', (ev) => {
				ev.preventDefault();
				const select = option.closest('[data-custom-select]');
				const value = option.getAttribute('data-custom-select-option');
				const title = option.innerText;
				CustomSelect.setSelected(select, value, title);
			})
		})
	},

	setSelected: (select, value, title) => {
		const selectInput = select.querySelector('[data-custom-select-select]');
		if(!selectInput) return;
		if(selectInput.value === value) return;
		selectInput.value = value;
		selectInput.dispatchEvent(new Event('change'));
		const current = select.querySelector(`[data-custom-select-current]`);
		if(!current){
		    return;
		}
		CustomSelect.closeOptions();
		current.innerText = title;
	},


}
export default CustomSelect;
